export class Queue {
  private _internalArray = []

  public get length() {
    return this._internalArray.length
  }

  public enqueue(val) {
    this._internalArray.push(val);
  }

  public dequeue() {
    return this._internalArray.shift();
  }

  public peek() {
    return this._internalArray[0];
  }

  public isEmpty() {
    return this._internalArray.length === 0;
  }

  public includes(val) {
    return this._internalArray.includes(val)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/queue/queue.ts